import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/app/about/components/AboutInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/medconsult_pro/src/components/common/Header.tsx");
